<template>
	<div id="app">
		<headerMenu @isReload="reload"></headerMenu>
		<router-view v-if="isChange" />
		<fooder v-if="isChange" :fooderMenu='fooderMenu'></fooder>
	</div>
</template>
<script>
	import * as Api from './service/index.js'
	import headerMenu from './components/header.vue'
	import fooder from './components/fooder'
	export default {
		provide() {
			return {
				reload: this.reload
			}
		},
		components: {
			headerMenu,
			fooder
		},
		data() {
			return {
				isChange: true,
				menu:'',
				fooderMenu:[]
			}
		},
		created() {
			this.getNav()
		},
		methods: {
			reload() {
				this.isChange = false
				this.getNav()
				this.$nextTick(() => {
					this.isChange = true
				})
			},
			getNav() {
				Api.getNav().then((res) => {
					if (res.code === 200) {
						this.fooderMenu = []
						this.menu = res.data
						this.menu.forEach((item,index)=>{
							if(item.child){
								item.customIsShow = false
								item.child.forEach((e,i)=>{
									e.parentUrl = item.url
									e.parentTitle = item.title
								})
							}
							if(item.id == 6 || item.id == 8){
								this.fooderMenu.push(item)
							}
						})
					}
				}).catch(() => {
			
				})
			},
		}
	}
</script>

<style scoped>
	@import './assets/css/common.css';

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #303133;
		font-size: 16px;
		font-family: Microsoft YaHei-Regular, Microsoft YaHei;
		background-color: #F2F2F2;
		padding-top: 115px;
	}

	@media screen and (max-width:768px) {
		#app {
			padding-top: 85px;
		}
	}
</style>
